export default __webpack_public_path__ + "static/media/portfolio-hover-206.cb4bb9cd.jpg";